import React, { useState } from 'react'
import LottiePlayer from 'lottie-react'

export const Lottie = ({ data }: { data: any }) => {
  const [animData, setAnimData] = useState(null)

  React.useEffect(() => {
    fetch(data.lottie)
      .then((res) => res.json())
      .then((json) => setAnimData(json))
  }, [data.lottie])

  return (
    <div className="mt-5">
      <div className="min-h-[269px]">
        {animData ? <LottiePlayer loop={false} animationData={animData} /> : null}
      </div>
      <h3 className="text-[96px] mt-5 leading-[104px] font-percent font-bold tracking-[-0.02em] text-center">
        {data?.title}
      </h3>
      <p
        className="text-base leading-relaxed font-medium  text-center text-[#101A36B2]"
        dangerouslySetInnerHTML={{ __html: data?.text }}
      ></p>
      <p
        className="text-[14px] leading-relaxed font-medium  text-center text-[#101A36B2] mt-8"
        dangerouslySetInnerHTML={{ __html: data?.description }}
      ></p>
    </div>
  )
}
